/** un file dizionario generale
 * IMPORTANTE usare il lowercase e controllare mandando in lowerCase
 * Non creare duplicati
 */
export const dictionary = {
  macrocategory: "Categoria",
  microcategory: "Sotto categoria",
  category: "Descrizione",
  ditta_cf: "Codice fiscale azienda",
  ditta_nome: "Nome azienda",
  ditta_denominazione: "Denominazione azienda",
  ditta_piva: "Partita Iva azienda",
  fiscale_periodo_al: "Data finale di riferimento",
  idobject: "ID knos di pubblicazione",
  info_file: "Nome file",
  time_stamp: "Timestamp",
  utente_nome: "Utente",
  documento_tipo: "Descrizione",
  fiscale_periodo_anno: "Periodo anno fiscale",
  trasmesso_cod: "Trasmesso codice",
  protocollo_attribuito: "Protocollo attribuito",
  progressivo_invio: "",
  esito: "Esito",
  file: "Nome file",
  ambiente: "Ambiente",
  ditta_codice: "Ditta codice",
  data_ricezione: "Data ricezione",
  doc_codice: "Codice documento",
  doc_subcodice: "Sottocodice documento",
  doc_descrizione: "Descrizione documento",
  fiscale_periodo_dal: "Periodo fiscale di partenza",
  start: "inizio",
  cod_au: "Codice anagrafica unica",
  id_anagrafica: "Id anagrafica",
  cf_intermediario: "Codice fiscale intermediario",
  fiscale_data_vers: "Data di versamento",
  fiscale_periodo_periodo: "Anno di riferimento",
  fiscale_data_doc: "Data documento",
  doc_numero: "Numero documento",
  doc_serie: "Codice sezionale registro iva",
  doc_serie_descrizione: "Descrizione sezionale registro iva",
  "documento.tipo": "Descrizione",
  progre: "Progressivo documento",
  cod_cli: "Codice cliente",
  cliente: "Denominazione cliente",
  descrizione_cli: "Descrizione aggiuntiva cliente",
  piva_cli: "Partita iva cliente",
  cfis_cli: "Codice fiscale cliente",
  cod_for: "Codice fornitore",
  fornitore: "Denominazione fornitore",
  descrizione_for: "Descrizione aggiuntiva fornitore",
  piva_for: "Partita iva fornitore",
  cfis_for: "Codice fiscale fornitore",
  trasmesso_nome: "Denominazione trasmittente",
  num_accolte: "Dichiarazioni accolte",
  num_pagamenti: "Numero pagamenti",
  num_scartate: "Numero scarti",
  num_trasmissioni: "Numero trasmissioni",
  vers_positivo: "Versamenti positivi",
  vers_zero: "Versamenti importo 0",
  utente_id: "Id utente",
  filiale_cod: "Codice filiale",
  filiale_desc: "Descrizione filiale",
  mat_inps_ditta: "Matricola INPS",
  mese_cod: "Numero mese",
  mese_desc: "Descrizione mese",
  mat_dip: "Matricola dipendente",
  cognome_nome_dip: "Cognome e nome dipendente",
  cod_fiscale_dip: "Codice fiscale dipendente",
  comune_dip: "Comune residenza dipendente",
  data_ass: "Data assunzione dipendente ",
  qualifica_cod: "Codice qualifica dipendente",
  qualifica_desc: "Descrizione qualifica dipendente",
  registro: "Codice registro",
  num_pag_i: "Pagina registro",
  annullato: "Contiene pagina annullata",
  pos_inail_ditta: "Posizione Inail azienda",
  data_cess: "Data cessazione dipendente",
  cod_centro_costo: "Codice centro di costo",
  centro_costo: "Descrizione centro di costo",
  cod_reparto: "Codice centro di reparto",
  "status.name": "Stato",
  lynfa: "Ts Studio",
  "Dati Riepilogo.0.Imponibile Importo": "Riepilogo dati riga 1 Imponibile Importo",
  "Dati Riepilogo.0.Imposta": "Riepilogo dati riga 1 imposta",
  "Dati Riepilogo.0.Arrotondamento": "Riepilogo dati riga 1 arrotondamento",
  "Dati Pagamento.0.Condizioni Pagamento": "Dati pagamento riga 1 condizioni pagamento",
  "Dati Pagamento.0.Codice Modalita Pagamento": "Dati pagamento riga 1 codice modalita pagamento",
  "Dati Pagamento.0.Modalita Pagamento": "Dati pagamento riga 1 modalita pagamento",
  "Dati Pagamento.0.Importo Pagamento": "Dati pagamento riga 1 importo pagamento"
};
